import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  signal,
} from '@angular/core';

import { TellentNavigationItemBadge, TellentNavigationItemUpgrade } from '@core/tellent-types';
import { RtTooltip } from '@core/user-interface-legacy';
import { WalkthroughStepId } from '@core/walkthrough-types';
import { WalkthroughStepOriginDirective } from '@core/walkthrough-ui';

import { TellentNavigationLabelComponent } from '../navigation-label/navigation-label.component';

@Component({
  standalone: true,
  selector: 'tlc-navigation-link',
  styleUrls: ['../navigation.vars.less', './navigation-link.component.less'],
  templateUrl: './navigation-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: WalkthroughStepOriginDirective,
      inputs: ['rtWalkthroughOriginStepId: walkthroughId'],
    },
  ],
  host: {
    '[class]': 'classNames()',
  },
  imports: [TellentNavigationLabelComponent, NgTemplateOutlet, RtTooltip],
})
export class TellentNavigationLinkComponent {
  #elRef = inject(ElementRef);

  public isActive = input.required<boolean>();
  public isChild = input.required<boolean>();
  public isExpanded = input.required<boolean>();

  public testId = input.required<string>();
  public walkthroughId = input<WalkthroughStepId | undefined>();
  public href = input.required<string>();
  public minimized = input.required<boolean>();
  public label = input.required<string>();
  public icon = input<string | null>(null);
  public iconSvg = input<string | null>(null);
  public badges = input<TellentNavigationItemBadge[]>([]);
  public upgrade = input<TellentNavigationItemUpgrade>();

  public isHoverForced = signal<boolean>(false);

  public classNames = computed(() => ({
    'is-active': this.isActive(),
    'is-child': this.isChild(),
    'is-expanded': this.isExpanded() && !this.minimized(),
    'is-hover-forced': this.isHoverForced(),
  }));

  constructor() {
    effect(() => {
      if (this.isActive()) {
        this.#elRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  public onAnchorClick(event: MouseEvent) {
    if (!event.metaKey) event.preventDefault();
  }
}
